export const TYPE = {
    NUMBER: 'number',
    PASSWORD: 'password',
    TEXT: 'text',
    FILE: 'file',
} as const;

export const MASKTYPE = {
    CNPJ: 'cnpj',
    PHONE: 'phone',
    DECIMAL_SMALL: 'decimal_small',
    LOADS: 'loads',
} as const;

export const SIZE = {
    LG: 'lg',
    SM: 'sm',
} as const;
